// This is a like-for-like port of the GTM tags, so whatever they sent, we send. The


/**
 * Every event in trackingEventsMap goes to the second tracker, cf2026 / FanaticalReact2026.
 * The legacy pageload event in public/index.html stays on cf / FanaticalReact.
 *
 * The suffix goes on every method, not just the tracking verbs. A bare method name
 * fans out to all registered trackers, and the state these calls build up is
 * per-tracker-instance: setUserId / setCustomUrl / setReferrerUrl would otherwise
 * mutate cf too, and addTrans / addItem / trackTrans would buffer the order on one
 * tracker and flush it on another. Suffixing centrally here is what keeps them
 * consistent — a namespace that is not registered fails with a console warning and
 * no event, so cf2026 must exist before this runs.
 */

const TRACKER_NAMESPACE = 'cf2026';

const snowplowCall = (method, ...args) => {
  if (typeof window === 'undefined' || typeof window.snowplow !== 'function') return;
  window.snowplow(`${method}:${TRACKER_NAMESPACE}`, ...args);
};

const isNonEmptyString = value => typeof value === 'string' && value.length > 0;


let previousUrl = null;

const sendPageView = ({ userId }) => {
  const url = (typeof window !== 'undefined' && window.location && window.location.href) || null;
  if (previousUrl) snowplowCall('setReferrerUrl', previousUrl);
  if (url) snowplowCall('setCustomUrl', url);

  if (isNonEmptyString(userId)) snowplowCall('setUserId', userId);
  snowplowCall('trackPageView'); // Only trackPageView sends; the calls before it set tracker state, which v2's
  previousUrl = url;
};

const sendStruct = (descriptor) => {
  const { category, action, value, label, property, setUserId } = descriptor || {};

  if (!isNonEmptyString(category)) return;

  if (isNonEmptyString(setUserId)) snowplowCall('setUserId', setUserId);

  snowplowCall(
    'trackStructEvent',
    category,
    action,
    label,
    property,
    value,
  );
};

const sendTransaction = (descriptor) => {
  const { orderId, currency } = descriptor;

  // The blank args below were blank in GTM; currency is the one deliberate divergence
  snowplowCall(
    'addTrans',
    orderId,
    descriptor.affiliation || '',
    descriptor.total,
    descriptor.tax,
    '', // shipping
    '', // city
    '', // state
    '', // country
    currency || '',
  );

  // ti_currency is its own column, so items need it too
  (descriptor.items || []).forEach(item => snowplowCall(
    'addItem',
    orderId,
    item.sku || '', // we set sku to product._id in reportTosnowplow in receipt duck
    item.name || '',
    item.category || '',
    item.price,
    item.quantity,
    currency || '',
  ));

  snowplowCall('trackTrans');
};

const senders = {
  pageView: sendPageView,
  struct: sendStruct,
  transaction: sendTransaction,
};

export default function snowplowTarget(events) {
  events.forEach((event) => {
    if (!event || !event.event) return;
    const send = senders[event.event];
    if (send) send(event);
  });
}
